import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <hr className="hr" />
            <h4> &copy; <a href="/">IftixorDev</a> 2021-2022 | Made with development</h4>
        </div>
    )
}

export default Footer
